export default __webpack_public_path__ + "static/dfsHome-ca667cf07b0fda374493950ed9e15e80.png";